import React, { useState, useEffect, useMemo } from "react";
// import classes from "../../assets/styles/Pages/Function/CustomURLSListing.module.css";
import ShowPaymentFunctions from "../../components/PageComponents/Function/ShowPaymentFunctions";
import Loader from "../../components/Loader";
import AddIcon from "../../assets/images/global_icons/basil_add-solid.svg";
import { useAtom } from "jotai";
import { get, deleteRecord, post, put } from "../../server";
import { PAYMENT, FUNCTION_STATUS } from "../../utils/constants/apiUrl";
import {
  loggedInUser,
  teamIDCheck,
  subscribedPackage,
} from "../../utils/store";
import { toast } from "react-toastify";
import showToast from "../../helpers/showToast";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import CashAppAddEditModal from "../../components/Modals/CashAppAddEditModal";
import PaymentAddEditModal from "../../components/Modals/PaymentAddEditModal";
import addcontact from "../../assets/images/home_page_images/addcontact.svg";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import FormInput from "../../components/Forms/FormInput";
import searchIcon from "../../assets/images/global_icons/searchicon.svg";
import { formatUrl } from "../../utils/functions/index";
import _ from "lodash";
import EmptyListingBanner from "../../components/EmptyListingBanner";
import useFunctionsCount from "../../hooks/useFunctionsCount";
import functionTypes from "../../utils/constants/functionTypes";
import { FaCirclePlus } from "react-icons/fa6";
import FunctionsLimitModal from "../../components/Modals/FunctionsLimitModal";
import { useFunctionContext } from "../../context/FunctionContext";
import { trackEvent } from "../../utils/mixpanel";
import { Button, InputGroup } from "react-bootstrap";

const emptyPaymentData = {
  isNew: true,
  id: "",
  title: "",
  url_path: "",
  payment_type: "",
  dynamic_qr_code_id: "",
};

const PaymentListing = () => {
  const navigate = useNavigate();
  const { teamId, userId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(true);
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [cashApps, setCashApps] = useState([]);
  const [payments, setPayments] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [selectedData, setSelectedData] = useState(emptyPaymentData);
  const [filterText, setFilterText] = useState("");
  const {
    compareLimits,
    updateCount,
    limitExceededForStarter,
    compareLimitsForDynamicQR,
  } = useFunctionsCount();
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  // Handle main modal
  const handleShowModal = (obj) => {
    if (obj && Object.keys(obj).length) setSelectedData(obj);
    setShowModal(true);
  };

  // const handleShowPaymentModal = () => {
  //   const isLimitExceeded = compareLimits(functionTypes.PAYMENT);
  //   // if (isLimitExceeded)
  //   //   return showToast(
  //   //     false,
  //   //     "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
  //   //   );
  //   if (isLimitExceeded) {
  //     setShowLimitModal(true);
  //     return;
  //   }
  //   setShowModal(true);
  // };

  const handleShowPaymentModal = async () => {
    if (dynamicQRCodeId) {
      const isLimitExceeded = compareLimitsForDynamicQR(
        functionTypes?.PAYMENT,
        dynamicQRCodeId
      );
      if (isLimitExceeded) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        setShowModal(true);
      }
    } else if (purchasedPackage.id === 1) {
      limitExceededForStarter()
        .then((isLimitExceeded) => {
          if (isLimitExceeded) {
            setShowLimitModal(true);
          } else {
            setShowModal(true);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      const isLimitExceeded = compareLimits(functionTypes.PAYMENT);
      if (isLimitExceeded) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        setShowModal(true);
      }
    }
    // if (isLimitExceeded)
    //   return showToast(
    //     false,
    //     "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
    //   );

    // if (isLimitExceeded) {
    //   setShowLimitModal(true);
    //   return;
    // }
  };

  const handleSaveShowModal = async () => {
    setLoading(true);
    let payload = _.cloneDeep(selectedData);
    payload.url_path = formatUrl(payload.url_path);
    payload.dynamic_qr_code_id = dynamicQRCodeId;
    let result = {};

    if (selectedData.id) {
      result = await put(
        PAYMENT + `/${selectedData.id}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    } else {
      if (teamId && userId) {
        payload.team_id = teamId;
        payload.user_id = userId;
      }
      if (team_id && user_id) {
        payload.team_id = team_id;
        payload.user_id = user_id;
      }
      if (userTeamId) {
        payload.team_id = userTeamId;
      }
      result = await post(
        PAYMENT,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    }

    let { status, message, data } = result;

    if (status) {
      setLoading(false);

      let paymentArr = _.cloneDeep(payments);
      if (!selectedData.id) {
        updateCount(functionTypes.PAYMENT, functionTypes.ADD, dynamicQRCodeId);
      }
      // On Update
      if (selectedData.id) {
        const index = payments.findIndex((el) => el.id == selectedData.id);
        paymentArr[index] = data;
      } else {
        paymentArr.unshift(data);
      }

      setPayments(paymentArr);

      handleCloseModal();
    } else {
      setLoading(false);
    }

    showToast(status, message);
  };

  const handleCloseModal = () => {
    setSelectedData(emptyPaymentData);
    setShowModal(false);
    setShowLimitModal(false);
  };

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    const source = window.location.search.includes("dynamic_qr_code")
      ? "QR Code"
      : window.location.search.includes("team_id") &&
        window.location.search.includes("user_id")
      ? "Team Function"
      : "Function Page";

    trackEvent("Delete Attempt", {
      id,
      source,
      timestamp: new Date().toISOString(),
    });
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let queryParams = "";

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    if (teamId || team_id || userTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${
        teamId || team_id || userTeamId
      }`;
    }

    // if (teamId || team_id || userTeamId) {
    //   queryParams = `?team_id=${teamId || team_id || userTeamId}`;
    // }
    let { status, message } = await deleteRecord(
      `${PAYMENT}/${deleteId}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);

    if (status) {
      updateCount(functionTypes.PAYMENT, functionTypes.DELETE, dynamicQRCodeId);
      await getPayments();
      setLoading(false);
    }
    setLoading(false);
  };
  // Get all custom urls
  const getPayments = async () => {
    let queryParams = "";

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    if (teamId || team_id || userTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${
        teamId || team_id || userTeamId
      }`;
    }

    // if (teamId || team_id || userTeamId) {
    //   queryParams = `?team_id=${teamId || team_id || userTeamId}`;
    // }

    if (userId || user_id) {
      queryParams += `${queryParams ? "&" : "?"}user_id=${userId || user_id}`;
    }

    let { status, message, data } = await get(
      `${PAYMENT}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setPayments(data);
    } else {
      toast.error(message);
    }

    setLoading(false);
  };

  const handleStatus = async (id, payment_type) => {
    const allPayments = payments.find((payment) => payment.id === id);
    // const statusValues = payments.map((payment) => payment.status);
    let queryParams = "";

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }
    let type =
      payment_type === "venmo"
        ? "venmo"
        : payment_type === "cash_app"
        ? "cash_app"
        : "custom_payment";
    let newStatus = allPayments.status == true ? 0 : 1;

    const previousStatus = allPayments.status ? "Active" : "Inactive";
    const newStatusText = newStatus ? "Active" : "Inactive";

    const source = window.location.search.includes("dynamic_qr_code")
      ? "QR Code"
      : window.location.search.includes("team_id") &&
        window.location.search.includes("user_id")
      ? "Team Function"
      : "Function Page";
    const team_id = searchParams.get("team_id");
    const user_id = searchParams.get("user_id");
    const dynamic_qr_code = searchParams.get("dynamic_qr_code");
    const payload = {
      id: allPayments.id,
      status: newStatus,
      type: type,
      team_id: allPayments.team_id,
    };
    let { status, message } = await post(
      `${FUNCTION_STATUS}${queryParams}`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      trackEvent(`Payment Service Status Changed from ${source}`, {
        id,
        function_type: allPayments.function_type,
        new_status: newStatusText,
        previous_status: previousStatus,
        source,
        team_id,
        user_id,
        dynamic_qr_code,
      });
      await getPayments();
    } else {
      trackEvent(`Payment Service Status Change Failed from ${source}`, {
        id,
        function_type: allPayments.function_type,
        attempted_status: newStatusText,
        previous_status: previousStatus,
        source,
        team_id,
        user_id,
        dynamic_qr_code,
        error_message: message,
      });
      toast.error(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getPayments();
  }, [userTeamId]);

  const filteredItems = useMemo(() => {
    const filtered = payments.filter(
      (item) =>
        `${item.title || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.url_path || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, payments]);
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleTracking = (data) => {
    trackEvent(data, {
      message: data,
    });
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="mainWrapper heading">
            <h1 className="">
              {/* <Link
                  onClick={handleGoBack}
                  style={{ color: "var(--heading_text_color)" }}
                >
                  Functions
                </Link> */}
              <Link to="/" className="function-link">
                Functions
              </Link>
              {` > Payment Service`}
            </h1>
            {/* <div className="d-flex align-items-center justify-content-center">
              {payments.length !== 0 ? (
                <FormInput
                  icon={searchIcon}
                  placeholder="Search..."
                  value={filterText}
                  handleChange={handleFilter}
                />
              ) : null}
              {dynamicQRCodeId !== null ? (
                <Link className="primary_button ms-4" to={`/qrcode`}>
                  {`< Back`}
                </Link>
              ) : (
                ""
              )}
            </div> */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3 mobileViewWrapper">
              {(Object.keys(loggedUser).length !== 0 &&
                loggedUser.role.includes("customer")) ||
              loggedUser.role.includes("team_owner") ? (
                <Button variant="primary" onClick={handleShowPaymentModal}>
                  <img src={AddIcon} alt="plus" className="me-2" />
                  Add Payment Link
                </Button>
              ) : null}

              {dynamicQRCodeId !== null ? (
                <Link className="primary_button" to={`/qrcode`}>
                  {`< Back`}
                </Link>
              ) : null}
            </div>
          </div>
          <div className="mb-3">
            {payments.length !== 0 ? (
              // <FormInput
              //   icon={searchIcon}
              //   placeholder="Search..."
              //   value={filterText}
              //   handleChange={handleFilter}
              // />
              // <div className="input-group w-25">
              //   <span className="input-group-text bg-white border-end-0">
              //     <img
              //       src={searchIcon}
              //       alt="search"
              //       style={{ height: "16px" }}
              //     />
              //   </span>
              //   <input
              //     type="text"
              //     className="form-control border-start-0"
              //     placeholder="Search..."
              //     value={filterText}
              //     onChange={handleFilter}
              //   />
              // </div>
              <InputGroup className="w-25 form-group">
                <InputGroup.Text className="bg-white">
                  <img
                    src={searchIcon}
                    alt="search"
                    style={{ height: "16px" }}
                  />
                </InputGroup.Text>
                <input
                  type="text"
                  className="form-control border-start-0 input-group-form-control ps-2"
                  placeholder="Search..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </InputGroup>
            ) : null}
          </div>

          {payments.length === 0 ? (
            <EmptyListingBanner
              headLineText="payment links"
              title="Add Payment Link"
              // onClick={handleShowPaymentModal}
              onClick={() => {
                handleShowPaymentModal();
                handleTracking("Add Payment Link Clicked");
              }}
              showAdd={
                loggedUser.role.includes("customer") ||
                loggedUser.role.includes("team_owner")
              }
            />
          ) : (
            <div className="customURLSWrapper">
              <div>
                {/* <div className="addWrapper">
                  {(Object.keys(loggedUser).length !== 0 &&
                    loggedUser.role.includes("customer")) ||
                  loggedUser.role.includes("team_owner") ? (
                    <span onClick={handleShowPaymentModal}>
                      <div className="addContentWrapper">
                        <FaCirclePlus />
                        <p>Add Payment Link</p>
                      </div>
                    </span>
                  ) : null}
                </div> */}
                <ShowPaymentFunctions
                  loading={loading}
                  show={showModal}
                  payments={filteredItems}
                  handleShowModal={handleShowModal}
                  handleCloseModal={handleCloseModal}
                  handleDelete={handleDelete}
                  handleStatus={handleStatus}
                  getPayments={getPayments}
                  dynamicQRCodeId={dynamicQRCodeId}
                />
              </div>
            </div>
          )}

          {/* Cash app modals */}
          {showModal && (
            <PaymentAddEditModal
              show={showModal}
              data={selectedData}
              setSelectedData={setSelectedData}
              handleSaveShowModal={handleSaveShowModal}
              handleCloseModal={handleCloseModal}
            />
          )}
        </div>
      )}

      {/* confirmation modal */}

      <ConfirmationModal
        show={showConfirmationModal}
        handleCloseModal={handleCloseConfirmationModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="payment service"
      />
      <FunctionsLimitModal
        show={showLimitModal}
        handleClose={handleCloseModal}
        getData={getPayments}
      />
    </>
  );
};

export default PaymentListing;
